import './App.css';
import Header from './components/home/Header';
import Sentaku from './components/home/Sentaku';
import Tab from './components/home/Tab';

function App() {
  return (
    <div className="App">
      <Tab />
      <Header />
      <Sentaku />
    </div>
  );
}

export default App;